﻿import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';
import { haptic } from '../lib/telegram';
import type { ImportJob } from '../types/import';

export function useImportUpload() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (file: File) => {
      const form = new FormData();
      form.append('file', file);
      return api<ImportJob>('/import/zip', {
        method: 'POST',
        body: form,
      });
    },
    onSuccess: async () => {
      haptic.success();
      await qc.invalidateQueries({ queryKey: ['import-jobs'] });
    },
    onError: () => haptic.error(),
  });
}
